export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/60 via-background-50 to-accent-100/40"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-200/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-200/20 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-6 md:pt-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              热门漫画免费在线阅读
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              皮皮喵漫画 · 你的追漫好伙伴
            </h1>

            <p className="text-base md:text-lg text-foreground-700 mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              韩漫的细腻情感、日漫的热血冒险、国漫的文化底蕴，皮皮喵漫画用心收录三大品类热门漫画。
              每日同步更新连载，分类清晰查找方便，无论你是老漫迷还是新入坑，都能在这里发现属于你的下一部心头好。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-6">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">2600+</span>
                <span className="text-xs md:text-sm text-foreground-600">部漫画资源</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">每日</span>
                <span className="text-xs md:text-sm text-foreground-600">同步更新</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">15+</span>
                <span className="text-xs md:text-sm text-foreground-600">细分类型</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer text-sm md:text-base"
              >
                <i className="ri-fire-line mr-1.5"></i>查看热门排行
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-full hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap text-center cursor-pointer text-sm md:text-base"
              >
                <i className="ri-compass-3-line mr-1.5"></i>探索主题分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20young%20person%20sitting%20comfortably%20on%20a%20cozy%20sofa%20reading%20manga%20on%20a%20tablet%20device%20colorful%20manga%20panels%20and%20speech%20bubbles%20floating%20around%20in%20the%20air%20warm%20indoor%20lighting%20modern%20minimal%20living%20room%20vibrant%20orange%20and%20coral%20accents%20stylized%20digital%20illustration%20with%20soft%20gradients%20anime%20inspired%20art%20style%20joyful%20atmosphere%20clean%20composition&width=600&height=500&seq=hero-main-visual&orientation=landscape"
                alt="皮皮喵漫画 - 畅享高清漫画在线阅读"
                title="皮皮喵漫画 - 韩漫日漫国漫在线阅读"
                className="w-full h-auto rounded-2xl object-cover"
              />
              <div className="absolute -bottom-3 -left-3 bg-background-50 rounded-xl px-4 py-2.5 flex items-center gap-2 border border-background-200/70">
                <span className="w-6 h-6 flex items-center justify-center bg-primary-100 rounded-full">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">日更漫画实时同步</span>
              </div>
              <div className="absolute -top-2 -right-2 bg-background-50 rounded-xl px-4 py-2.5 flex items-center gap-2 border border-background-200/70">
                <span className="w-6 h-6 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-heart-fill text-accent-500 text-xs"></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">50万+读者信赖</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}